<template>
  <div>
    <!-- AI客服浮动按钮 -->
    <div
      class="fixed-right-buttons"
      :class="{ 'collapsed': isCollapsed }"
      :style="{
        right: `${position.right}px`,
        bottom: `${position.bottom}px`,
      }"
    >
      <!-- 收缩-->
      <el-icon color="#03A9F4" :size="15" class="close-icon" @click="toggleCollapse">
        <CaretRight />
      </el-icon>
      <img :src="buttonIcon" :alt="buttonText" class="button-icon" @click="toggleChat"/>
      <!-- 背景模糊效果 -->
      <!-- <div class="fixed-right-buttons-background">
        <div class="gradient-background"></div>
      </div> -->

      <!-- 按钮内容 -->
      <!-- <div class="button-content" @click="toggleChat">
              <img 
          :src="buttonIcon" 
          :alt="buttonText" 
          class="button-icon" 
        >
        <div class="button-text">{{ buttonText }}</div>
      </div> -->
    </div>
    <!-- 展开-->
     <div
       v-show="isCollapsed"
       class="collapsed-handle"
       :style="{right: `${position.right}px`, bottom: `${position.bottom}px`,}"
       @click="toggleCollapse"
     >
       <el-icon :size="20" color="#03A9F4" style="margin-left: 0;"><CaretLeft /></el-icon>
     </div>

    <!-- 聊天组件 -->
    <chatGpt
      v-if="!isMobile"
      v-show="isVisible"
      @childClick="toggleChat"
      :chatGptShow="isVisible"
    ></chatGpt>
    <van-popup
      v-else
      v-model:show="isVisible"
      round
      class="vanPop"
      :overlay="false"
      position="right"
      :style="{ width: '100%', height: '100%' }"
      style="margin-top: 12rem"
    >
      <!-- 聊天组件 -->
      <chatGpt
        v-show="isVisible"
        @childClick="toggleChat"
        :chatGptShow="isVisible"
      ></chatGpt>
    </van-popup>
  </div>
</template>

<script setup>
import { ref, defineProps, defineEmits, watch, onMounted } from "vue";
import { useI18n } from "vue-i18n";
import chatGpt from "@/component/chatGpt.vue";

// Props 定义
const props = defineProps({
  // 按钮位置
  position: {
    type: Object,
    default: () => ({ right: 40, bottom: 200 }),
  },
  // 按钮文字
  buttonText: {
    type: String,
    default: "AI客服",
  },
  // 初始显示状态
  initialVisible: {
    type: Boolean,
    default: false,
  },
});

// Emits 定义
const emit = defineEmits(["toggle", "show", "hide"]);
//
const { t } = useI18n();

const isCollapsed = ref(false);
const isMobile = window.innerWidth <= 768;
// 响应式数据
const isVisible = ref(props.initialVisible);
// 按钮图标
const buttonIcon = ref(require("@/assets/ai/" + t("AiChat.buttonIcon")));
// 切换聊天窗口显示状态
const toggleChat = () => {
  isVisible.value = !isVisible.value;

  // 发射事件
  emit("toggle", isVisible.value);
  if (isVisible.value) {
    emit("show");
  } else {
    emit("hide");
  }
};
// 切换右侧折叠/展开
const toggleCollapse = () => {
  isCollapsed.value = !isCollapsed.value;
};

// 暴露方法供父组件调用
defineExpose({
  show: () => {
    isVisible.value = true;
    emit("show");
  },
  hide: () => {
    isVisible.value = false;
    emit("hide");
  },
  toggle: toggleChat,
  isVisible: () => isVisible.value,
});
</script>

<style scoped>
.fixed-right-buttons {
  position: fixed;
  width: 270px;
  height: 120px;
  z-index: 90;
  cursor: pointer;
  transition: transform 0.3s ease;
}
.fixed-right-buttons.collapsed {
  transform: translateX(120%);
}
.close-icon {
  display: none;
}

.fixed-right-buttons-background {
  width: 100%;
  height: calc(100% + 10px);
  position: absolute;
  top: 0px;
  filter: blur(8px);
  opacity: 0.25;
  border-radius: 20px;
  margin-bottom: 10px;
  overflow: hidden;
}

.gradient-background {
  width: 100%;
  height: 100%;
  position: absolute;
  filter: blur(5px);
  transform: translate3d(0px, 0px, 0px);
  will-change: transform, left, top;
  background: radial-gradient(
      circle at 50% 25%,
      rgb(21, 72, 255) 5%,
      rgba(21, 72, 255, 0) 60%
    ),
    radial-gradient(
      circle at 75% 50%,
      rgb(255, 100, 50) 5%,
      rgba(255, 100, 50, 0) 70%
    ),
    radial-gradient(
      circle at 50% 75%,
      rgb(123, 71, 255) 5%,
      rgba(123, 71, 255, 0) 80%
    ),
    rgb(37, 165, 255);
}

.button-content {
  position: absolute;
  text-align: center;
  box-sizing: border-box;
  display: flex;
  flex-direction: column;
  border-radius: 20px;
  background: rgb(255, 255, 255);
  cursor: pointer;
  width: 100%;
  height: 100%;
  padding: 8px;
  transition: all 0.3s ease;
}

.button-content:hover {
  transform: scale(1.05);
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);
}

.button-icon {
  width: 100%;
  cursor: pointer;
  object-fit: contain;
}

.button-text {
  width: 100%;
  display: block;
  font-size: 14px;
  line-height: 16px;
  font-weight: 500;
  margin: 0px auto 10px;
  color: #333;
}

/* 响应式设计 */
@media (max-width: 768px) {
  .fixed-right-buttons {
    width: 100Px;
    height: 60px;
  }
  .close-icon {
    display: block;
    float: right;
  }
  .button-text {
    font-size: 12px;
    line-height: 14px;
  }

  .collapsed-handle {
    position: fixed; 
    width: 70px;
    height: 70px;
    z-index: 90;
  }
}
</style>